<template>
    <div class="goTop">
      <div class="userCourseList">
        <el-backtop>UP</el-backtop>
        <!-- <h3>我的课程</h3> -->
        <h2>您一共有 <span>{{this.total}}</span> 门课程在学习中</h2>
        <!-- <el-image v-for="course in myCourseList" :key="course.id" :src="course.course_cover_image" lazy @click="goLessonPage(course.id,course.course_name)"></el-image> -->
        <!-- 加入图片懒加载功能支持 -->
        <!-- <img v-lazy="img.src"/> -->
        <img v-for="course in myCourseList" :key="course.id" v-lazy="course.course_cover_image" @click="goLessonPage(course.id,course.course_name)" />
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        query: '',
        pageNum: 1,
        pageSize: 2,
        token: ''
      },
      myCourseList: [],
      total: 0
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getMyCourse()
  },
  methods: {
    async getMyCourse () {
      const { data: res } = await this.$http.get('V2/courselist/', { params: this.queryInfo })
      this.myCourseList = res
      this.total = res.length
      console.log(this.myCourseList)
      console.log(this.total)
      if (res.total === 0) return this.$notify({ title: '失败', message: '获取个人授权课程失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取个人已授权课程成功!', type: 'success' })
    },
    goLessonPage (courseId, courseName) {
      // this.$router.push('/lessons')
      // 不能使用params进行传参，因为通过name跳转，不能跳转到子路由,只能通过query传参
      // this.$router.push({ name: 'lessons', params: { course_id: courseId } })
      this.$router.push({ path: '/lessons', query: { course_id: courseId, course_name: courseName } })
    }
  }
}
</script>

<style lang="less" scoped>
  .userCourseList{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 10px;
    align-items: center;
    >el-image{
      width: 80% !important;
    }
    >h2 span{
      font-size: 50px;
      color: coral;
      font-weight: 600;
    }
    >img{
      padding-top: 15px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .el-image{
    padding-top: 15px;
    border-radius: 5px;
    cursor: pointer;
  }
  .goTop{
    // height: 100px;
    overflow-x: hidden;
  }
</style>
